// src/pages/CourseTime/components/slides/common/KeyPointsList.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import { renderPlainTextWithFormatting, parseInlineMarkdown } from '../../../utils';
import SlideTitleSpoken, { resolveSlideTitle } from './SlideTitleSpoken.comp';

// The intro-line / icon+phrase+description bullet list / closing-line block,
// shared by TemplateList's `key_points` branch and TemplateHtmlContent's.
const KeyPointsList = ({
  slide,
  skipTitleSpeech,
  renderSpokenText,
  intro,
  closing,
  points
}) => (
  <S.HtmlContentColumn>
    {resolveSlideTitle(slide).trim() && (
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>
    )}
    <S.HtmlContentWrapper>
      {intro && (
        <div className="intro-line">
          {renderPlainTextWithFormatting(intro)}
        </div>
      )}
      {points && points.length > 0 && (
        <ul className="key-points">
          {points.map((p, idx) => (
            <li key={idx}>
              <span className="icon">{p.icon}</span>
              <div className="key-point-copy">
                <div className="key-point-phrase">
                  <strong>{parseInlineMarkdown(p.verb_phrase)}</strong>
                </div>
                {p.description && (
                  <div className="key-point-desc">
                    {parseInlineMarkdown(p.description)}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
      {closing && (
        <div className="key-points-closing">
          {renderPlainTextWithFormatting(closing)}
        </div>
      )}
    </S.HtmlContentWrapper>
  </S.HtmlContentColumn>
);

export default KeyPointsList;
